import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { ApiService } from "../../services/api.service";

import { Observable, of } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  tap,
  switchMap,
} from "rxjs/operators";

@Component({
  selector: "app-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.css"],
})
export class FormComponent implements OnInit {
  params: any = {};
  lead: any = {
    insurance: "",
    age: "",
    job: "",
    hour: "",
    extraData: {},
  };

  lastResults: any = [];

  backActive: boolean = false;
  showSMS: boolean = false;
  showCall: boolean = false;
  leadId: string;
  searching: boolean = false;
  extraValues: boolean = false;
  errors: any = [];
  nextStep = false;
  callNow = true;
  stepCount = 0;
  loading: boolean = false;
  code: string = "";
  error: boolean = false;
  editPhone: boolean = false;
  color: string = "#28a745"; // hover color #218838
  bgColor: string = this.color;

  insurances: any = [
    {
      id: 1,
      description: "Polizza rimborso spese sanitarie",
      value: "rimborso-spese-sanitarie",
    },
    { id: 2, description: "Polizza infortuni", value: "infortuni" },
    { id: 3, description: "Polizza sulla vita", value: "vita" },
    { id: 4, description: "Polizza casa", value: "casa" },
    { id: 11, description: "Polizza dentistica", value: "dentistica" },
    {
      id: 5,
      description: "Polizza responsabilità capo famiglia",
      value: "responsabilita-civile",
    },
    {
      id: 6,
      description: "Pensione integrativa",
      value: "pensione-integrativa",
    },
    {
      id: 7,
      description: "Polizza rc professionale",
      value: "rc-professionale",
    },
    { id: 8, description: "Polizza tutela legale", value: "tutela-legale" },
    { id: 9, description: "Polizza viaggio", value: "viaggio" },
    { id: 10, description: "Polizza uomo chiave", value: "key-man" },
    { id: 12, description: "Polizza LTC", value: "ltc" },
    { id: 13, description: "Polizza caso vita", value: "caso-vita" },
  ];

  ages: any = [
    { id: 1, description: "Meno di 20 anni", value: "20" },
    { id: 2, description: "Da 20 a 24 anni", value: "20-25" },
    { id: 3, description: "Da 25 a 29 anni", value: "25-30" },
    { id: 4, description: "Da 30 a 34 anni", value: "30-35" },
    { id: 5, description: "Da 35 a 39 anni", value: "35-40" },
    { id: 6, description: "Da 40 a 44 anni", value: "40-45" },
    { id: 7, description: "Da 45 a 49 anni", value: "45-50" },
    { id: 8, description: "Da 50 a 54 anni", value: "50-55" },
    { id: 9, description: "Da 55 a 59 anni", value: "55-60" },
    { id: 10, description: "Da 60 a 64 anni", value: "60-65" },
    { id: 11, description: "Da 65 a 70 anni", value: "65-70" },
  ];

  jobs: any = [
    { id: 1, description: "Agente immobiliare", value: "agente-immobiliare" },
    { id: 2, description: "Agricoltore", value: "agricoltore" },
    { id: 3, description: "Architetto", value: "architetto" },
    { id: 4, description: "Artigiano", value: "artigiano" },
    { id: 5, description: "Avvocato", value: "avvocato" },
    { id: 6, description: "Commerciante", value: "commerciante" },
    { id: 7, description: "Commercialista", value: "commercialista" },
    { id: 8, description: "Dirigente d'azienda", value: "dirigente-azienda" },
    { id: 10, description: "Geometra", value: "geometra" },
    { id: 11, description: "Ingegnere", value: "ingegnere" },
    {
      id: 12,
      description: "Lavoratore dipendente (settore pubblico)",
      value: "dipendente-pubblico",
    },
    {
      id: 13,
      description: "Lavoratore dipendente (settore privato)",
      value: "dipendente-privato",
    },
    {
      id: 14,
      description: "Libero professionista",
      value: "libero-professionista",
    },
    { id: 15, description: "Medico", value: "medico" },
    { id: 16, description: "Pensionato", value: "pensionato" },
    { id: 18, description: "Titolare d'Azienda", value: "titolare" },
  ];

  constructor(
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private api: ApiService
  ) {}

  async ngOnInit() {
    try {
      if (localStorage.getItem("user")) {
        if (!this.lead.extraData) {
          this.lead.extraData = {};
        }
      }
    } catch (e) {
      console.error(e);
    }

    this.route.queryParams.subscribe(async (params) => {
      this.params = params;
      let paramLead;
      if (this.params.lead) {
        paramLead = JSON.parse(this.params.lead);
      }
      this.lead.affiliate = this.params.aff_id;
      this.lead.host = this.params.host;
      this.lead.aff_ref = this.params.aff_ref;
      this.lead.url = this.params.url;

      if (this.params.type) {
        this.lead.insurance = params.type;

        if (params.type == "cani-gatti") {
          this.stepCount = -1;
          this.lead.extraData.age = "";
        }
      }

      if (paramLead) {
        this.lead.name = paramLead.name;
        this.lead.surname = paramLead.surname;
        this.lead.phone = paramLead.phone;
        this.errors["phone"] = this.eleads_validate_phone(this.lead.phone);
        this.lead.email = paramLead.email;
        this.errors["email"] = this.eleads_validate_email(this.lead.email);
        this.lead.zip = { zipcode: paramLead.zipcode };

        this.api.getLocation(paramLead.zipcode).subscribe((r) => {
          console.log("ZIP", r);
          if (r[0]) {
            this.lead.zip.name = r[0].name;
            this.lead.city = r[0].name;
          } else {
            this.lead.zip = {};
          }
        });
      }

      if (this.params.btn_color) {
        this.color = this.params.btn_color;
        this.bgColor = this.params.btn_color;
      }
    });

    let today = new Date();
    let dayNumber = today.getDay();
    let currentHour = today.getHours() + today.getMinutes() / 60;

    if (
      dayNumber == 0 ||
      dayNumber == 6 ||
      (currentHour < 9.5) ||
      currentHour > 20
    ) {
      this.callNow = false;
    }

    this.cd.detectChanges();
  }

  check(property) {
    switch (property) {
      case "name":
        if (this.lead.name.length >= 2) {
          this.errors["name"] = false;
        } else {
          this.errors["name"] = true;
        }

        break;

      case "surname":
        if (this.lead.surname.length >= 2) {
          this.errors["surname"] = false;
        } else {
          this.errors["surname"] = true;
        }

        break;

      case "email":
        this.errors["email"] = this.eleads_validate_email(this.lead.email);
        break;

      case "phone":
        this.errors["phone"] = this.eleads_validate_phone(this.lead.phone);
        break;

      case "zip":
        if (this.lead.zip.name && this.lead.zip.zipcode) {
          this.errors["zip"] = false;
        } else if (this.lastResults.length > 0) {
          this.lead.city = this.lastResults[0].name;
          this.lead.zip = this.lastResults[0];
          this.errors["zip"] = false;
        } else {
          this.errors["zip"] = true;
        }

      default:
        if (this.lead[property] != "") {
          this.errors[property] = false;
        } else {
          this.errors[property] = true;
        }
        break;
    }
  }

  formatMatches = (value: any) => value.zipcode + " - " + value.name || "";
  formatMatchesInput = (value: any) => value.zipcode || "";
  selectedItem(item) {
    this.lead.city = item.item.name;
    this.errors["zip"] = false;
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => (this.searching = true)),
      switchMap((term) =>
        this.api.getLocation(term).pipe(
          tap((obj: any) => {
            this.lastResults = [];
            this.lastResults = obj;
          }),
          catchError(() => {
            return of([]);
          })
        )
      ),
      tap(() => (this.searching = false))
    );

  eleads_validate_email(email) {
    email = email.replace(/ /g, "");
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(String(email).toLowerCase());
  }

  eleads_validate_phone(phone) {
    phone = phone.replace(/ /g, "");
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{3,6}$/im;
    return !re.test(String(phone).toLowerCase());
  }

  eleads_validate_cap(cap) {
    var re = /^[0-9]{5}$/;
    return !re.test(String(cap).toLowerCase());
  }

  verify() {
    this.loading = true;
    var code = { code: this.code };
    this.api.verify(this.leadId, code).subscribe(
      (success) => {
        let double = success.double;
        this.loading = false;
        this.stepCount++;

        localStorage.setItem("user", JSON.stringify(this.lead));
        window.parent.postMessage(
          { sender: "e-leads", message: "done", id: this.leadId, double },
          "*"
        );
      },
      (error) => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  next() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    var goOn = true;
    switch (this.stepCount) {
      case -1:
        goOn = this.checkExtraValues();

        if (goOn) {
          this.backActive = true;
          this.stepCount++;
          window.scrollTo(0, 0);
        }
        break;

      case 0:
        if (this.lead.insurance == "") {
          goOn = false;
          this.errors["insurance"] = true;
        } else {
          this.errors["insurance"] = false;
        }

        if (this.lead.age == "") {
          goOn = false;
          this.errors["age"] = true;
        } else {
          this.errors["age"] = false;
        }

        if (!this.lead.gender) {
          goOn = false;
          this.errors["gender"] = true;
        } else {
          this.errors["gender"] = false;
        }

        if (!this.lead.name || this.errors["name"]) {
          goOn = false;
          this.errors["name"] = true;
        } else {
          this.errors["name"] = false;
        }

        if (!this.lead.surname || this.errors["surname"]) {
          goOn = false;
          this.errors["surname"] = true;
        } else {
          this.errors["surname"] = false;
        }

        if (goOn) {
          this.stepCount++;
          this.backActive = true;
          window.scrollTo(0, 0);
        }
        break;

      case 1:
        if (this.lead.job == "") {
          goOn = false;
          this.errors["job"] = true;
        } else {
          this.errors["job"] = false;
        }

        if (!this.lead.zip || this.errors["zip"]) {
          goOn = false;
          this.errors["zip"] = true;
        } else {
          this.errors["zip"] = false;
        }

        if (goOn) {
          this.stepCount++;
          window.scrollTo(0, 0);
        }

        break;

      case 2:
        if (!this.lead.phone || this.errors["phone"]) {
          goOn = false;
          this.errors["phone"] = true;
        } else {
          this.errors["phone"] = false;
        }

        if (!this.lead.email || this.errors["email"]) {
          goOn = false;
          this.errors["email"] = true;
        } else {
          this.errors["email"] = false;
        }

        if (!this.lead.privacy_data) {
          goOn = false;
          this.errors["privacy_data"] = true;
        } else {
          this.errors["privacy_data"] = false;
        }

        if (goOn) {
          this.loading = true;

          var lead = this.lead;
          lead.cap = lead.zip.zipcode;
          this.api.postLead(this.lead).subscribe(
            (id: any) => {
              var verify = id.verify;

              if (id.verify) {
                this.leadId = id.id;
                this.stepCount++;
                this.backActive = false;
                this.loading = false;
                this.api.sendSMS(this.leadId).subscribe();
              } else {
                this.leadId = id.id;
                this.stepCount += 2;
                this.loading = false;
              }

              window.parent.postMessage(
                { sender: "e-leads", message: "verify", id: this.leadId },
                "*"
              );

              window.scrollTo(0, 0);
            },
            (error) => {
              this.loading = false;
              this.error = true;
              window.scrollTo(0, 0);
            }
          );
        }
        break;

      case 3:
        break;

      default:
        break;
    }
  }

  sendSMS() {
    var phone = { phone: this.lead.phone };
    this.api.editPhone(this.leadId, phone).subscribe((success) => {
      this.api.sendSMS(this.leadId).subscribe(
        (success) => {
          this.showSMS = true;
        },
        (error) => {
          this.error = true;
        }
      );
    });
  }

  sendCall() {
    var phone = { phone: this.lead.phone };
    this.api.editPhone(this.leadId, phone).subscribe(
      (success) => {
        this.api.sendCall(this.leadId).subscribe(
          (success) => {
            this.showCall = true;
          },
          (error) => {
            this.error = true;
          }
        );
      },
      (error) => {
        this.error = true;
      }
    );
  }

  prev() {
    // this.lead.zip=this.lead.zip.zipcode; //we need to do this before sending the data
    this.stepCount--;

    switch (this.lead.insurance) {
      case "cani-gatti":
        if (this.stepCount >= 0 && this.stepCount < 3) {
          this.backActive = true;
        } else {
          this.backActive = false;
        }
        break;

      default:
        if (this.stepCount >= 1 && this.stepCount < 3) {
          this.backActive = true;
        } else {
          this.backActive = false;
        }
        break;
    }
  }

  checkData(step) {
    var goOn = false;
    switch (step) {
      case 0:
        break;
    }
  }

  mouseEnter() {
    var rgb = this.hexToRgb(this.color);

    // create a darker shade for hover effect
    rgb.r *= 0.8;
    rgb.g *= 0.8;
    rgb.b *= 0.8;

    this.bgColor = this.rgbToHex(rgb.r, rgb.g, rgb.b);
  }

  mouseLeave() {
    this.bgColor = this.color;
  }

  checkExtraValues(): boolean {
    var goOn = true;

    if (!this.lead.extraData.type) {
      this.errors["type"] = true;
      goOn = false;
    } else {
      this.errors["type"] = false;
    }

    if (!this.lead.extraData.age) {
      this.errors["animal-age"] = true;
      goOn = false;
    } else {
      this.errors["animal-age"] = false;
    }

    if (this.lead.extraData.microchip == undefined) {
      this.errors["microchip"] = true;
      goOn = false;
    } else {
      this.errors["microchip"] = false;
    }

    if (this.lead.extraData.sick == undefined) {
      this.errors["sick"] = true;
      goOn = false;
    } else {
      this.errors["sick"] = false;
    }

    if (!this.lead.extraData.specie) {
      this.errors["specie"] = true;
      goOn = false;
    } else {
      this.errors["specie"] = false;
    }

    if (!this.lead.extraData.race) {
      this.errors["race"] = true;
      goOn = false;
    } else {
      this.errors["race"] = false;
    }

    return goOn;
  }

  //-------------------------------- FUNCTION TO TRANSFORM HEX COLOR TO RGB AND BACK

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  rgbToHex(red, green, blue) {
    var rgb = blue | (green << 8) | (red << 16);
    return "#" + (0x1000000 + rgb).toString(16).slice(1);
  }

  public onFocusSelect(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event("input");
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }
}
